<template>
    <div style="z-index:1002" class="">
        <b-navbar toggleable="sm" type="dark" class="bgray-100 header-nav px-lg-4" >
            <!-- <b-navbar-brand>
                <div @click="pageGo" class="">
                    <b-img class="cursor header-logo" src="/images/QESG_Assessment_basic.svg"></b-img>
                </div>
            </b-navbar-brand> -->
            <b-navbar-brand v-show="!['ParticipatePreface', 'Questions'].includes($route.name)" :to="{ name: 'Main' }">
                <b-img class="cursor header-logo" src="/images/QESG_Assessment_basic.svg" alt="QESG Assessment"></b-img>
            </b-navbar-brand>

            <b-navbar-nav v-show="['ParticipatePreface', 'Questions'].includes($route.name)">
                <b-nav-item :to="{ name: 'Main' }" link-classes="text-secondary f-95">
                    <BIconArrowLeft class="mr-1" />
                    {{ $t('진행중인 평가 목록으로 나가기') }}
                </b-nav-item>
            </b-navbar-nav>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <!-- 버튼을 b-nav-item(a 링크) 안에 두면 링크 안에 버튼이 중첩돼 li 로 감싼다 -->
                <b-navbar-nav class="ml-auto d-sm-flex align-items-sm-center" >
                    <div class="d-block f-85 gray-600">
                        <b-badge v-if="is_premium" variant="info" class="white-text-badge">Premium User</b-badge>
                        {{ $t('hello', { company_name, user_name }) }}
                    </div>
                    <li class="nav-item">
                        <b-dropdown  id="my-info" size="sm" variant="dark-border" class="btn-round-2 ml-2 ml-sm-4"
                            :toggle-attrs="{ 'aria-label': $t('내 정보 관리') }" >
                            <template #button-content>
                                <fa :icon="['far','user']"></fa>
                            </template>
                            <b-dropdown-item @click.prevent="showMyInfo">
                                {{ $t('내 정보 관리') }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </li>
                    <!-- 공지사항(알림 종) 진입점은 숨김: 서버 공지 API 가 삭제됨(df_backend_custom af1fd8a5). Notice.vue 는 남겨 둔다 (2026-10-16 사용자 결정) -->
                    <li class="nav-item">
                        <b-button id="faq"
                            size="sm"
                            variant="dark-border"
                            class="btn-round-2 ml-2"
                            :aria-label="`FAQ & ${$t('사용 매뉴얼')}`"
                            @click.prevent="showFaq"
                            >
                            <fa icon="book"></fa>
                        </b-button>
                    </li>
                    <li class="nav-item">
                        <template v-if="is_admin >= 2">
                            <b-button id="go-to-user-main"
                                size="sm"
                                variant="blue-border"
                                class="btn-round-4 ml-2 ml-sm-3"
                                :to="{ name:'ProjectCodeList' }"
                                >
                                {{ $t('관리자') }}
                            </b-button>
                        </template>
                        <template v-if="is_admin === 4">
                            <b-button
                                :to="{ name: 'ManagingAssessment' }"
                                link-classes="h5 mb-0"
                                class="btn-round-4 ml-2 mr-1"
                                size="sm"
                                variant="blue-border"
                                >
                                📣 운영관리
                            </b-button>
                        </template>
                    </li>
                    <li class="nav-item">
                        <dropdown-language class="ml-2 ml-sm-3" size="sm" />
                    </li>
                    <li class="nav-item">
                        <b-button
                            variant="dark-border"
                            class="btn-round-4 ml-2 ml-sm-3"
                            size="sm"
                            @click="logout"
                            > {{ $t('로그아웃') }}
                        </b-button>
                    </li>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-tooltip target="my-info" triggers="hover focus"> {{ $t('내 정보 관리') }}</b-tooltip>
        <b-tooltip target="faq" triggers="hover focus"> FAQ & {{ $t('사용 매뉴얼') }} </b-tooltip>
        <b-tooltip target="go-to-user-main" triggers="hover focus"> {{ $t('관리자 페이지로 이동') }} </b-tooltip>

        <b-modal id="modify-modal-top" ref="my-info" size="lg" :title="$t('내 정보 관리')" hide-footer>
            <user-info @user-save="hideMyInfoModal"></user-info>
        </b-modal>
        <b-modal id="modify-modal-top" ref="faq" size="lg" :title="'FAQ & '+ $t('사용 매뉴얼')" hide-footer scrollable >
            <faq></faq>
        </b-modal>
    </div>
</template>

<script>
import { BIconArrowLeft } from 'bootstrap-vue';
import UserInfo from '@shared_components/utils/UserInfo';
import Faq from '@shared_components/utils/Faq';
import DropdownLanguage from '@shared_components/utils/dropdown-language';

import { mapState } from 'vuex';

export default {
    name: 'customheader',
    components: {
        BIconArrowLeft,
        UserInfo,
        Faq,
        DropdownLanguage
    },
    computed: {
        ...mapState(['user_id', 'company_id', 'user_name', 'company_name', 'e_mail', 'is_admin', 'campaign_in_progress']),
        ...mapState('payment', ['is_premium']),
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
    methods: {
        logout(){
            this.$store.dispatch('logout').then(() => { this.$router.push({name:'Login'});  } );
        },
        showMyInfo() {
            this.$refs['my-info'].show();
        },
        showFaq() {
            this.$refs['faq'].show();
        },
        showComments(){
            this.$refs['received-comments'].show();
        },
        pageGo(){
            this.$router.push({name:'Main'});
        },
        hideMyInfoModal(){
            this.$refs['my-info'].hide();
        }
    }
};
</script>

<style>
.header-nav > div.navbar-brand, .header-nav > div>ul>li>a.nav-link {
    padding:0!important;
}
.header-nav >.navbar-toggler {
    border-color: transparent;
}

.header-nav >.navbar-toggler >.navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(100,100,100,0.7)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")
}

@media (max-width: 574px) {
    .header-nav > div> ul.navbar-nav  {
        margin-top: 0.75rem;
        display: inline-block!important;
    }
    .header-nav > div> ul>li  {
        float:left!important;
    }

}
#my-info > ul {
    z-index: 1030;
}
.white-text-badge {
  color: white !important;
}
</style>
